import React, { useEffect, useState, useCallback } from "react";
import axiosInstance from "../axiosConfig";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import "../assets/CSS/Dashboard.css";


const RMIssueLogs = () => {
  const [logs, setLogs] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);

    const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };


 // 1️⃣ Pull the current user's Name from localStorage
  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const rawName  = userData.Name || "";
  // Title‐case it so it matches your [USER NAME] column
  const currentUser =
    rawName.charAt(0).toUpperCase() + rawName.slice(1).toLowerCase();




  // const fetchData = useCallback(async () => {
  //   try {
  //     const queryParams = [];
  //     if (fromDate) queryParams.push(`from=${fromDate}`);
  //     if (toDate) queryParams.push(`to=${toDate}`);
  //     const queryString = queryParams.length ? `?${queryParams.join("&")}` : "";

  //     const res = await axiosInstance.get(`/api/rm-issued-list${queryString}`);
  //     setLogs(res.data);
  //   } catch (err) {
  //     console.error("Failed to fetch logs:", err);
  //   }
  // }, [fromDate, toDate]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // const handleFilter = () => {
  //   fetchData();
  // };

//   const handleMarkDone = async (lotId) => {
//     try {
//       await axiosInstance.post("/api/rm-issued-done", { lotId });
//       setLogs((prev) =>
//         prev.map((row) =>
//           row["LOT ID"] === lotId ? { ...row, NotificationSent: "Yes" } : row
//         )
//       );
//     } catch (err) {
//       console.error("Failed to update NotificationSent:", err);
//       alert("❌ Failed to mark as done.");
//     }
//   };

  // 2️⃣ Fetch function includes from/to/userName as query params
  const fetchData = useCallback(async () => {
    try {
      const params = new URLSearchParams();
      if (fromDate)    params.append("from", fromDate);
      if (toDate)      params.append("to", toDate);
      if (currentUser) params.append("userName", currentUser);

      const qs = params.toString() ? `?${params}` : "";
      const res = await axiosInstance.get(`/api/rm-issued-list${qs}`);
      setLogs(res.data);
    } catch (err) {
      console.error("❌ Failed to fetch logs:", err);
    }
  }, [fromDate, toDate, currentUser]);

  // 3️⃣ Initial load & re-load whenever filters change
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // 4️⃣ Handler for manual filter button
  const handleFilter = () => {
    fetchData();
  };

  const pendingLogs = logs.filter((row) => row.NotificationSent !== "Yes");
  const completedLogs = logs.filter((row) => row.NotificationSent === "Yes");


  const handleConfirm = async (id) => {
  try {
    await axiosInstance.patch("api/confirm-rm-issue", { id });
    setLogs((prev) =>
      prev.map((row) =>
        row.Id === id ? { ...row, confirmedDateTime: "✔️ Confirmed" } : row
      )
    );
  } catch (err) {
    console.error("❌ Failed to confirm RM issue:", err);
    alert("❌ Failed to confirm RM issue.");
  }
};


  return (
     <div className="d-flex dashboard">
      <div
        className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}
      >
        <Sidebar />
      </div>
       <div className="flex-grow-1">
        <Header
          toggleSidebar={toggleSidebar}
          isSidebarVisible={isSidebarVisible}
        />
         <main className="main-container p-4" style={{ height: "-webkit-fill-available" }}>
    <div className="container mt-4">
      <h4 className="mb-3">📄 RM Issued Logs</h4>

      <div className="card p-3 shadow-sm mb-4">
        <div className="row g-3 align-items-end">
          <div className="col-md-3">
            <label className="form-label">From Date</label>
            <input
              type="date"
              className="form-control"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label">To Date</label>
            <input
              type="date"
              className="form-control"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="col-md-2">
            <button className="btn btn-primary w-100" onClick={handleFilter}>
              🔍 Filter
            </button>
          </div>
        </div>
      </div>

      <div className="table-responsive shadow-sm">
        <table className="table table-bordered table-striped align-middle">
          <thead className="table-dark">
            <tr>
              <th>ITEM NAME</th>
              <th>BARCODE</th>
              <th>LOT NUMBER</th>
              <th>LOT ID</th>
              <th>ISSUE DATE</th>
              <th>USER NAME</th>
              <th>QTY USED</th>
              <th>Action</th>

           
            </tr>
          </thead>
          <tbody>
            {[...pendingLogs, ...completedLogs].map((row, idx) => (
              <tr key={idx}>
                <td>{row["ITEM NAME"]}</td>
                <td>{row["BARCODE"]}</td>
                <td>{row["LOT NUMBER"]}</td>
                <td>{row["LOT ID"]}</td>
                <td>{row["ISSUE DATE"] || 'N/A'}</td>
                <td>{row["USER NAME"]}</td>
                <td>{row["QTY_USED"]}</td>
                <td>
                {row.confirmedDateTime ? (
                  <button
                    className="btn btn-success btn-sm"
                    disabled
                    style={{ cursor: "not-allowed" }}
                  >
                    Confirmed
                  </button>
                ) : (
                  <button
                    className="btn btn-outline-primary btn-sm"
                    onClick={() => handleConfirm(row.Id)}
                  >
                    Confirm
                  </button>
                )}
              </td>
                
              </tr>
            ))}
            {logs.length === 0 && (
              <tr>
                <td colSpan="8" className="text-center">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
    </main>
     </div>
     </div>
  );
};

export default RMIssueLogs;
